import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6">
      <div className="text-center max-w-md">
        <p className="text-sm tracking-[0.3em] text-[#D4AF37] mb-4">404</p>
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Page not found</h1>
        <p className="text-gray-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center px-6 py-3 rounded-full bg-[#D4AF37] text-black font-semibold hover:bg-[#FFD700] transition"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
}
